import { LeadSourceConfigDto, LeadSourceOptionsDto, SaveLeadSourceDto } from '@sr/dto';
import { settingsApi } from '../api';

export const leadSourcesApi = settingsApi.injectEndpoints({
  endpoints: (builder) => ({
    getLeadSources: builder.query<LeadSourceConfigDto[], void>({
      query: () => 'lead-sources',
      providesTags: ['lead-sources'],
    }),
    getLeadSourceOptions: builder.query<LeadSourceOptionsDto, void>({
      query: () => 'lead-sources/options',
    }),
    saveLeadSource: builder.mutation<LeadSourceConfigDto, { id?: number; data: SaveLeadSourceDto }>({
      query: ({ id, data }) => ({ url: id === undefined ? 'lead-sources' : `lead-sources/${id}`, method: id === undefined ? 'POST' : 'PUT', body: data }),
      invalidatesTags: ['lead-sources'],
    }),
    deleteLeadSource: builder.mutation<void, number>({
      query: (id) => ({ url: `lead-sources/${id}`, method: 'DELETE' }),
      invalidatesTags: ['lead-sources'],
    }),
  }),
});
